import { render } from "./ProjectsMapHead.vue?vue&type=template&id=061b9090"
import script from "./ProjectsMapHead.vue?vue&type=script&lang=js"
export * from "./ProjectsMapHead.vue?vue&type=script&lang=js"

import "./ProjectsMapHead.vue?vue&type=style&index=0&id=061b9090&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__